import {MyopMessages} from "../../common/MyopMessages";
import {SetInnerHtml} from "../../messages";
import {BaseMessageHandler} from "../../common";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class SetInnerHtmlHandler extends BaseMessageHandler<SetInnerHtml> {

    messageType = MyopMessages.SetInnerHtml;

    executor = (event: SetInnerHtml) => {
        const items = getElementsByRef(event.ref, document);
        items.forEach(item => {
            // @ts-ignore
            item.innerHTML = event.content;
        })
    }
}
